import { TitlePrimary } from 'mage-deps/@klarna/bubble-ui'
import { components as coreComponents } from 'mage-core'
import { hooks as i18nHooks } from 'mage-i18n'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React from 'react'

const Greeting = ({ givenName }) => {
  const t = i18nHooks.useTranslator()
  const message = t('hqm.home.greeting', { givenName }, `Hello ${givenName}! How can we help you?`)

  return (
    <TitlePrimary id="uhqm-sidebar-home-title" small>
      {message}
    </TitlePrimary>
  )
}

Greeting.propTypes = {
  givenName: PropTypes.string
}

export default R.compose(
  coreComponents.withTokenHelper(tokenHelper => ({
    givenName: tokenHelper.getGivenName()
  }))
)(Greeting)
